module.exports = __webpack_public_path__ + "static/media/badge_premium.25927df3.svg";